// extracted by mini-css-extract-plugin
export default {"section":"Section_section__06lK0","container":"Section_container__xwA4N","title":"Section_title__kR3xc","centered":"Section_centered__QUqwz"};